
<cu-card-resolver [card]="card" [page]="page" [pageSubmitted$]="pageSubmitted$" [cardIndex]="cardIndex"></cu-card-resolver>
